"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Type", {
  enumerable: true,
  get: function get() {
    return _TypeImpl.TypeImpl;
  }
});
var _TypeImpl = require("./TypeImpl");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVHlwZS9UeXBlLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgdHlwZSB7IEZvbnRGYW1pbHksIFR5cGVQcm9wcyB9IGZyb20gJy4vVHlwZUltcGwnO1xuZXhwb3J0IHsgVHlwZUltcGwgYXMgVHlwZSB9IGZyb20gJy4vVHlwZUltcGwnO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUNBIn0=